/**
 * Settings — account-level controls for the project owner.
 *
 * Currently houses:
 *   - Cascade Test Mode (contractor email safety toggle)
 *
 * Will grow over time as we add more user-level preferences (notifications,
 * default templates, etc.).
 *
 * Route: /settings
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Settings as SettingsIcon } from 'lucide-react';
import CascadeTestModeBanner from '@/components/CascadeTestModeBanner';
import CompanyBrandingCard from '@/components/CompanyBrandingCard';
import WhatsNewAdminCard from '@/components/WhatsNewAdminCard';
import FeatureGatesAdminCard from '@/components/FeatureGatesAdminCard';
import { isV255User } from '@/lib/featureFlags';
import { APP_VERSION } from '@/lib/version';

export default function Settings({ user }) {
  const navigate = useNavigate();
  const v255 = isV255User(user);

  return (
    <div className="min-h-screen bg-slate-50 px-4 sm:px-6 py-6" data-testid="settings-page">
      <div className="max-w-3xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="text-xs text-slate-500 hover:text-slate-900 inline-flex items-center gap-1 mb-2"
          data-testid="settings-back-btn"
        >
          <ArrowLeft className="w-3 h-3" />
          Back
        </button>

        <div className="flex items-center gap-2 mb-5">
          <SettingsIcon className="w-5 h-5 text-slate-700" />
          <h1 className="text-xl font-bold text-slate-900">Settings</h1>
        </div>

        <div className="space-y-4">
          {v255 && <CompanyBrandingCard user={user} />}
          <FeatureGatesAdminCard user={user} />
          <WhatsNewAdminCard user={user} />
          <CascadeTestModeBanner user={user} compact={false} />
        </div>

        <p className="text-xs text-slate-400 mt-8 text-center" data-testid="settings-app-version">
          DrawReady {APP_VERSION}
        </p>
      </div>
    </div>
  );
}
